import React, { useState, useEffect } from 'react';
import { Power, UserPlus, Trash2, Shield, Clock, Send, Check, X, ShieldAlert } from 'lucide-react';

const AdminTelegram = () => {
    const [botAtivo, setBotAtivo] = useState(false);
    const [contatos, setContatos] = useState([]);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // O formulário agora pede o Chat ID em vez do telemóvel
    const [novoContato, setNovoContato] = useState({ nome: '', chat_id: '', cargo: '' });

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

            const [resConfig, resContatos, resLogs] = await Promise.all([
                fetch('/api/telegram/admin/config', { headers }),
                fetch('/api/telegram/admin/contatos', { headers }),
                fetch('/api/telegram/admin/logs', { headers })
            ]);

            if (resConfig.ok) {
                const config = await resConfig.json();
                setBotAtivo(config.bot_ativo === 1);
            }
            if (resContatos.ok) setContatos(await resContatos.json());
            if (resLogs.ok) setLogs(await resLogs.json());

        } catch (error) {
            console.error("Erro ao carregar dados do Telegram Admin:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // Atualiza os logs a cada 10 segundos para ver novas mensagens a chegar
        const interval = setInterval(fetchData, 10000);
        return () => clearInterval(interval);
    }, []);

    const toggleBot = async () => {
        const novoStatus = !botAtivo;
        setBotAtivo(novoStatus); 
        try {
            const token = localStorage.getItem('authToken');
            await fetch('/api/telegram/admin/config', {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ bot_ativo: novoStatus })
            });
            fetchData(); 
        } catch (error) { console.error("Erro", error); }
    };

    const handleAddContato = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch('/api/telegram/admin/contatos', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(novoContato)
            });
            if (res.ok) {
                setNovoContato({ nome: '', chat_id: '', cargo: '' }); 
                fetchData(); 
            } else { alert("Erro. Verifique se este Chat ID já está registado."); }
        } catch (error) { console.error("Erro", error); }
    };

    const handleToggleAcesso = async (id, statusAtual) => {
        try {
            const token = localStorage.getItem('authToken');
            await fetch(`/api/telegram/admin/contatos/${id}`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ ativo: !statusAtual })
            });
            fetchData();
        } catch (error) { console.error("Erro", error); }
    };

    const handleDeleteContato = async (id) => {
        if (!window.confirm("Deseja remover o acesso deste colaborador?")) return;
        try {
            const token = localStorage.getItem('authToken');
            await fetch(`/api/telegram/admin/contatos/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            fetchData();
        } catch (error) { console.error("Erro", error); }
    };

    if (loading && logs.length === 0) return <div style={{ padding: '20px' }}>A carregar painel do Telegram...</div>;

    return (
        <div style={{ padding: '20px', backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            
            <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', flexWrap: 'wrap', gap: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ padding: '12px', backgroundColor: '#e0f2fe', borderRadius: '12px', color: '#0ea5e9' }}>
                        <Send size={28} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '24px', fontWeight: '800', margin: '0 0 4px 0', color: '#0f172a' }}>Gestão do Robô Telegram</h2>
                        <p style={{ color: '#64748b', margin: 0, fontSize: '14px' }}>
                            Controle de acessos e monitorização em tempo real das solicitações de BI.
                        </p>
                    </div>
                </div>
                
                <button onClick={toggleBot} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 24px', borderRadius: '50px', cursor: 'pointer', fontWeight: '700', fontSize: '16px', border: 'none', transition: 'all 0.3s', backgroundColor: botAtivo ? '#10b981' : '#ef4444', color: '#fff' }}>
                    <Power size={20} />
                    {botAtivo ? 'Robô LIGADO' : 'Robô DESLIGADO'}
                </button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '25px' }}>
                
                {/* COLUNA ESQUERDA */}
                <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <h3 style={{ fontSize: '18px', fontWeight: '700', borderBottom: '2px solid #f1f5f9', paddingBottom: '15px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Shield color="#3b82f6" size={20} /> Contactos Autorizados 
                    </h3>
                    
                    <form onSubmit={handleAddContato} style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
                        <input type="text" placeholder="Nome (ex: João Diretor)" value={novoContato.nome} onChange={e => setNovoContato({...novoContato, nome: e.target.value})} required style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
                        <input type="text" placeholder="Chat ID (Numérico)" value={novoContato.chat_id} onChange={e => setNovoContato({...novoContato, chat_id: e.target.value})} required style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
                        <input type="text" placeholder="Cargo" value={novoContato.cargo} onChange={e => setNovoContato({...novoContato, cargo: e.target.value})} required style={{ width: '120px', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
                        <button type="submit" style={{ backgroundColor: '#0284c7', color: '#fff', border: 'none', borderRadius: '8px', padding: '0 15px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <UserPlus size={18} /> Adicionar
                        </button>
                    </form>

                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f8fafc', color: '#64748b', textAlign: 'left' }}>
                                <th style={{ padding: '12px' }}>Nome / Cargo</th>
                                <th style={{ padding: '12px' }}>Chat ID</th>
                                <th style={{ padding: '12px' }}>Acesso</th>
                                <th style={{ padding: '12px', textAlign: 'right' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contatos.length === 0 ? <tr><td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>Nenhum acesso concedido.</td></tr> : null}
                            {contatos.map(c => (
                                <tr key={c.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                    <td style={{ padding: '12px' }}><strong>{c.nome}</strong><br/><span style={{ fontSize: '12px', color: '#64748b' }}>{c.cargo}</span></td>
                                    <td style={{ padding: '12px', color: '#475569', fontFamily: 'monospace' }}>{c.chat_id}</td>
                                    <td style={{ padding: '12px' }}>
                                        <button onClick={() => handleToggleAcesso(c.id, c.ativo)} style={{ padding: '6px 12px', borderRadius: '20px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px', backgroundColor: c.ativo ? '#dcfce7' : '#fee2e2', color: c.ativo ? '#16a34a' : '#ef4444' }}>
                                            {c.ativo ? <Check size={14}/> : <X size={14}/>} {c.ativo ? 'Permitido' : 'Bloqueado'}
                                        </button>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'right' }}>
                                        <button onClick={() => handleDeleteContato(c.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}><Trash2 size={18} /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* COLUNA DIREITA: LOGS */}
                <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', overflowY: 'auto', maxHeight: '600px' }}>
                    <h3 style={{ fontSize: '18px', fontWeight: '700', borderBottom: '2px solid #f1f5f9', paddingBottom: '15px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Clock color="#8b5cf6" size={20} /> Histórico de Pedidos
                    </h3>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {logs.length === 0 ? <div style={{ textAlign: 'center', color: '#64748b' }}>Nenhum registo de interação. Mande uma mensagem para o robô.</div> : null}
                        {logs.map(log => {
                            const isSuccess = log.status_resposta === 'Enviado com Sucesso';
                            const isBlocked = log.status_resposta.includes('Bloqueado');
                            
                            return (
                                <div key={log.id} style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f8fafc', borderLeft: `4px solid ${isSuccess ? '#10b981' : isBlocked ? '#ef4444' : '#f59e0b'}` }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                        <strong style={{ fontSize: '14px', color: '#0f172a' }}>{log.nome_solicitante} <span style={{ color: '#64748b', fontWeight: 'normal', fontFamily: 'monospace' }}>({log.chat_id})</span></strong>
                                        <span style={{ fontSize: '12px', color: '#94a3b8' }}>{new Date(log.data_hora).toLocaleString('pt-PT')}</span>
                                    </div>
                                    <div style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
                                        Mensagem: <i>"{log.mensagem_recebida}"</i>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 'bold', color: isSuccess ? '#10b981' : isBlocked ? '#ef4444' : '#f59e0b' }}>
                                        {isBlocked ? <ShieldAlert size={14} /> : <Check size={14} />} Ação: {log.status_resposta}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdminTelegram;